export default __webpack_public_path__ + "static/media/NotoSans_regular.b763a236.ttf";